import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const msnMedium155100Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.55,
  type: 'Image155x100',
  associationType: 'ImageMedia155X100',
  imagePreviewHeight: 194,
  minimumRequirements: 0,
  minSize: [300, 194],
  localizedText: {
    previewTypeStringKey: _TL_('MSN medium headline'),
    stringKey: _TL_('1.55 : 1'),
  },
  previewSettings: {
    showAdsLabelWithBusinessName: true,
    showBusinessName: true,
    showImage: true,
    showLongHeadline: true,
    showMultipleLineLongHeadline: true,
    showAdditionalDisclaimer: true,
  },
  styleOverrides: {
    businessNameWithAds: {
      padding: '1px 0',
      marginTop: 9,
      '& .adslabel': {
        border: '.5px solid #78718a',
        color: '#78718a',
        fontSize: 10,
        fontWeight: 400,
        lineHeight: '13.64px',
        textDecorationThickness: 'auto',
        textSizeAdjust: '100%',
        borderRadius: '4px',
        background: '#fff',
        padding: '.8px 4px',
        margin: '0 5px 0 0',
      },
      '& .business-name': {
        color: '#333',
        fontSize: 11,
        lineHeight: '15.004px',
        padding: '1px 0',
      },
    },
    previewContent: {
      margin: 'auto',
      background: '#fff',
      border: 'solid',
      borderWidth: 'thin',
      color: '#ddd',
    },
    textContainer: {
      padding: '15px 13px',
      color: '#333',
      height: 98,
    },
  },
};

export default msnMedium155100Raw;
